import React from 'react';
import { Taxonomy } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { TitleHeaderBlock } from '../../../components';

const PillarsHomeOverview = ({ onLoadMore, pager, loading, entities, ...props }) => {
  const entity = props.entity.toJS();
  const title = entity.field_label[0]?.value ?? null;
  // get legacy field_text and strip html tags from body in case it is used
  const body = entity.field_text[0]?.processed?.replace(/(<([^>]+)>)/gi, '') ?? '';

  return (
    <div className="View PillarsHomeOverview">
      {title && (
        <TitleHeaderBlock
          title={title}
          body={body}
        />
      )}
      <Container>
        <div className="row">
          {entities.map((e) => {
            const entity = e.toJS();
            const id = entity.tid[0].value;
            const uuid = entity.uuid[0].value;
            const langcode = entity.langcode[0].value;
            const className = 'col-12 col-md-3 pillar__teaser-container';

            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Taxonomy
                  id={id}
                  entity={e}
                  isActivePath
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default PillarsHomeOverview;
